import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ShippingInventryService {
  controller: string = 'admin/shipping/inventory';

  inventryType: BehaviorSubject<any> = new BehaviorSubject(null);
  location: BehaviorSubject<any> = new BehaviorSubject(null);
  supplierType: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    private router: Router) {
    this.get_inventory_type_list();
    this.get_location_list();
    this.get_inventory_supplier_list();
  }
  // Location
  get_location_list() {
    this.httpService.get(`${this.controller}/get_location_list`).subscribe(res => {
      if (res['success']) {
        this.location.next(res['data'][0]);
      }
    });
  }
  add_location(obj: any) {
    return this.httpService.post(`${this.controller}/add_location`, obj);
  }
  // Inventry Type
  get_inventory_type_list() {
    this.httpService.get(`${this.controller}/get_inventory_type_list`).subscribe(res => {
      if (res['success']) {
        this.inventryType.next(res['data'][0]);
      }
    });
  }
  add_inventory_type(obj: any) {
    return this.httpService.post(`${this.controller}/add_inventory_type`, obj);
  }
  // Supplier
  get_inventory_supplier_list() {
    this.httpService.get(`${this.controller}/get_inventory_supplier_list`).subscribe(res => {
      if (res['success']) {
        this.supplierType.next(res['data'][0]);
      }
    });
  }
  add_inventory_supplier(obj: any) {
    return this.httpService.post(`${this.controller}/add_inventory_supplier`, obj);
  }
  // Packaging
  get_packging_list(obj: any) {
    return this.httpService.post(`${this.controller}/get_packging_list`, obj);
  }
  add_packaging(obj: any) {
    return this.httpService.post(`${this.controller}/add_packaging`, obj);
  }
  delete_packaging(obj: any) {
    return this.httpService.post(`${this.controller}/delete_packaging`, obj);
  }
  update_packaging(obj: any) {
    return this.httpService.post(`${this.controller}/update_packaging`, obj);
  }
}
